import axiosInstance from '../Core/RestHelper';
import { AuthResponse, User , UserVerification, UserVerificationResponse} from '../Model/User';

export class AuthService {

  static async getGithubAuthUrl(): Promise<string> {
    try {
      const response = await axiosInstance.get('/git/login/');
      return response.data.url;
    } catch (error) {
      throw new Error('Failed to get GitHub auth URL');
    }
  }

  static async handleGithubCallback(code: string, installation_id?: number): Promise<AuthResponse> {
    try {
      const response = await axiosInstance.get<AuthResponse>(
        `/git/callback`,
        {
          params: { 'code':code, "installation_id":installation_id },
          withCredentials: true 
        }
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to authenticate with GitHub');
    }
  }

  // New Bitbucket methods
  static async getBitbucketAuthUrl():  Promise<string> {
    try {
      const response = await axiosInstance.get('/bitbucket/login/');
      return response.data.url;
    } catch (error) {
      throw new Error('Failed to get Bitbucket auth URL');
    }
  }

  static async handleBitbucketCallback(code: string):  Promise<AuthResponse> {
    try {
      const response = await axiosInstance.get(
        `/bitbucket/callback_bitbucket`,
        {
          params: { code },
          withCredentials: true 
        }
      );
     
      return response.data;
    } catch (error) {
      throw new Error('Failed to authenticate with Bitbucket');
    }
  }

  static async getCurrentUser(): Promise<User> {
    try {
      const response = await axiosInstance.get(
        `/user`,
        {
          withCredentials: true 
        }
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch user data');
    }
  }

  static async verifyUser(req: UserVerification): Promise<UserVerificationResponse> {
    try {
      const response = await axiosInstance.post(
        `/admin/mfa/verify`, req
      );
      return response.data;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error';
      throw new Error(`Failed to verify user: ${errorMessage}`);
    }
  }


  static logout(): Promise<void> {
    return axiosInstance.post(
      `/logout`,
      {},
      { withCredentials: true }
    );
  }
}